import FilterConstants from './filter-constants';

// NOTE: yticks option of -1 invokes special case code on figures/graph - otherwise all graph options run straight through to ember-aditools-graph
export default {
  'filter-type': [],
  specifications: [
    {
      name: FilterConstants.figureName.magnitudeDb,
      figure: 'figures/graph',
      annotation: 'annotations/specifications-magnitude',
      source: 'magnitudeDb',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.db',
        hoverTitles: { headerLabel: 'figures.magnitudeDb.x-hover', lineLabels: ['figures.magnitudeDb.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.magnitudeVV,
      figure: 'figures/graph',
      annotation: 'annotations/specifications-response',
      source: 'magnitudeVV',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.vv',
        hoverTitles: { headerLabel: 'figures.magnitudeVV.x-hover', lineLabels: ['figures.magnitudeVV.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.phaseDegrees,
      figure: 'figures/graph',
      annotation: 'annotations/specifications-response',
      source: 'phaseDegrees',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.degree',
        hoverTitles: { headerLabel: 'figures.phaseDegrees.x-hover', lineLabels: ['figures.phaseDegrees.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.phaseRadians,
      figure: 'figures/graph',
      annotation: 'annotations/specifications-response',
      source: 'phaseRadians',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: -1,
        yticks: 6,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.radian',
        hoverTitles: { headerLabel: 'figures.phaseRadians.x-hover', lineLabels: ['figures.phaseRadians.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.groupDelay,
      figure: 'figures/graph',
      annotation: 'annotations/specifications-response',
      source: 'groupDelay',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~s',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.second',
        hoverTitles: { headerLabel: 'figures.groupDelay.x-hover', lineLabels: ['figures.groupDelay.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.phaseDelay,
      figure: 'figures/graph',
      annotation: 'annotations/specifications-response',
      source: 'phaseDelay',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~s',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.second',
        hoverTitles: { headerLabel: 'figures.phaseDelay.x-hover', lineLabels: ['figures.phaseDelay.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.stepResponse,
      figure: 'figures/graph',
      annotation: 'annotations/specifications-response',
      source: 'stepResponse',
      options: {
        xscale: 'linear',
        xformat: '.3~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: 8,
        yticks: 8,
        hover: true,
        xUnit: 'units.second',
        yUnit: 'units.vv',
        hoverTitles: { headerLabel: 'figures.stepResponse.x-hover', lineLabels: ['figures.stepResponse.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.stages,
      figure: 'figures/stages',
      annotation: null,
      source: null,
      options: { xscale: 'log', yscale: 'linear' },
    },
  ],
  components: [
    {
      name: FilterConstants.figureName.magnitudeDb,
      figure: 'figures/graph',
      annotation: null,
      source: 'magnitudeDb',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.db',
        hoverTitles: { headerLabel: 'figures.magnitudeDb.x-hover', lineLabels: ['figures.magnitudeDb.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.magnitudeVV,
      figure: 'figures/graph',
      annotation: null,
      source: 'magnitudeVV',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.vv',
        hoverTitles: { headerLabel: 'figures.magnitudeVV.x-hover', lineLabels: ['figures.magnitudeVV.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.phaseDegrees,
      figure: 'figures/graph',
      annotation: null,
      source: 'phaseDegrees',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.degree',
        hoverTitles: { headerLabel: 'figures.phaseDegrees.x-hover', lineLabels: ['figures.phaseDegrees.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.phaseRadians,
      figure: 'figures/graph',
      annotation: null,
      source: 'phaseRadians',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: -1,
        yticks: 6,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.radian',
        hoverTitles: { headerLabel: 'figures.phaseRadians.x-hover', lineLabels: ['figures.phaseRadians.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.groupDelay,
      figure: 'figures/graph',
      annotation: null,
      source: 'groupDelay',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~s',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.second',
        hoverTitles: { headerLabel: 'figures.groupDelay.x-hover', lineLabels: ['figures.groupDelay.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.phaseDelay,
      figure: 'figures/graph',
      annotation: null,
      source: 'phaseDelay',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~s',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.second',
        hoverTitles: { headerLabel: 'figures.phaseDelay.x-hover', lineLabels: ['figures.phaseDelay.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.stepResponse,
      figure: 'figures/graph',
      annotation: null,
      source: 'stepResponse',
      options: {
        xscale: 'linear',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: 8,
        yticks: 8,
        hover: true,
        xUnit: 'units.second',
        yUnit: 'units.vv',
        hoverTitles: { headerLabel: 'figures.stepResponse.x-hover', lineLabels: ['figures.stepResponse.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.inputImpedanceMagnitude,
      figure: 'figures/graph',
      annotation: null,
      source: 'inputImpedanceMagnitude',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'log',
        yformat: '.3~s',
        xticks: -1,
        yticks: -1,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.ohm',
        hoverTitles: {
          headerLabel: 'figures.inputImpedanceMagnitude.x-hover',
          lineLabels: ['figures.inputImpedanceMagnitude.y-hover'],
        },
      },
    },
    {
      name: FilterConstants.figureName.inputImpedancePhase,
      figure: 'figures/graph',
      annotation: null,
      source: 'inputImpedancePhase',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.degree',
        hoverTitles: {
          headerLabel: 'figures.inputImpedancePhase.x-hover',
          lineLabels: ['figures.inputImpedancePhase.y-hover'],
        },
      },
    },
    {
      name: FilterConstants.figureName.noise,
      figure: 'figures/noise',
      annotation: null,
      source: 'noise',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'log',
        yformat: '.3~s',
        xticks: -1,
        yticks: -1,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.snd',
        hoverTitles: { headerLabel: 'figures.noise.x-hover', lineLabels: ['figures.noise.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.power,
      figure: 'figures/power',
      annotation: null,
      source: 'power',
      options: null,
    },
    {
      name: FilterConstants.figureName.voltageRange,
      figure: 'figures/voltage-range',
      annotation: null,
      source: 'voltageRange',
      options: null,
    },
    {
      name: FilterConstants.figureName.stages,
      figure: 'figures/stages',
      annotation: null,
      source: null,
      options: { xscale: 'log', yscale: 'linear' },
    },
    {
      name: FilterConstants.figureName.circuit,
      figure: 'figures/schematic',
      annotation: null,
      source: null,
      options: null,
    },
  ],
  tolerances: [
    {
      name: FilterConstants.figureName.magnitudeDb,
      figure: 'figures/graph',
      annotation: null,
      source: 'magnitudeDb',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.db',
        hoverTitles: { headerLabel: 'figures.magnitudeVV.x-hover', lineLabels: ['figures.magnitudeVV.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.magnitudeVV,
      figure: 'figures/graph',
      annotation: null,
      source: 'magnitudeVV',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.vv',
        hoverTitles: { headerLabel: 'figures.magnitudeVV.x-hover', lineLabels: ['figures.magnitudeVV.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.phaseDegrees,
      figure: 'figures/graph',
      annotation: null,
      source: 'phaseDegrees',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.degree',
        hoverTitles: { headerLabel: 'figures.phaseDegrees.x-hover', lineLabels: ['figures.phaseDegrees.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.phaseRadians,
      figure: 'figures/graph',
      annotation: null,
      source: 'phaseRadians',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: -1,
        yticks: 6,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.radian',
        hoverTitles: { headerLabel: 'figures.phaseRadians.x-hover', lineLabels: ['figures.phaseRadians.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.groupDelay,
      figure: 'figures/graph',
      annotation: null,
      source: 'groupDelay',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~s',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.second',
        hoverTitles: { headerLabel: 'figures.groupDelay.x-hover', lineLabels: ['figures.groupDelay.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.phaseDelay,
      figure: 'figures/graph',
      annotation: null,
      source: 'phaseDelay',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~s',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.second',
        hoverTitles: { headerLabel: 'figures.phaseDelay.x-hover', lineLabels: ['figures.phaseDelay.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.stepResponse,
      figure: 'figures/graph',
      annotation: 'annotations/step-response-envelope',
      source: 'stepResponse',
      options: {
        xscale: 'linear',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: 8,
        yticks: 8,
        hover: true,
        xUnit: 'units.second',
        yUnit: 'units.vv',
        hoverTitles: { headerLabel: 'figures.stepResponse.x-hover', lineLabels: ['figures.stepResponse.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.inputImpedanceMagnitude,
      figure: 'figures/graph',
      annotation: null,
      source: 'inputImpedanceMagnitude',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'log',
        yformat: '.3~s',
        xticks: -1,
        yticks: -1,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.ohm',
        hoverTitles: {
          headerLabel: 'figures.inputImpedanceMagnitude.x-hover',
          lineLabels: ['figures.inputImpedanceMagnitude.y-hover'],
        },
      },
    },
    {
      name: FilterConstants.figureName.inputImpedancePhase,
      figure: 'figures/graph',
      annotation: null,
      source: 'inputImpedancePhase',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.degree',
        hoverTitles: {
          headerLabel: 'figures.inputImpedancePhase.x-hover',
          lineLabels: ['figures.inputImpedancePhase.y-hover'],
        },
      },
    },
    {
      name: FilterConstants.figureName.noise,
      figure: 'figures/noise',
      annotation: null,
      source: 'noise',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'log',
        yformat: '.3~s',
        xticks: -1,
        yticks: -1,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.snd',
        hoverTitles: { headerLabel: 'figures.noise.x-hover', lineLabels: ['figures.noise.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.power,
      figure: 'figures/power',
      annotation: null,
      source: 'power',
      options: null,
    },
    {
      name: FilterConstants.figureName.voltageRange,
      figure: 'figures/voltage-range',
      annotation: null,
      source: 'voltageRange',
      options: null,
    },
    {
      name: FilterConstants.figureName.stages,
      figure: 'figures/stages',
      annotation: null,
      source: null,
      options: { xscale: 'log', yscale: 'linear' },
    },
    {
      name: FilterConstants.figureName.circuit,
      figure: 'figures/schematic',
      annotation: null,
      source: null,
      options: null,
    },
  ],
  'next-steps': [
    {
      name: FilterConstants.figureName.magnitudeDb,
      figure: 'figures/graph',
      annotation: null,
      source: 'magnitudeDb',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.db',
        hoverTitles: { headerLabel: 'figures.magnitudeVV.x-hover', lineLabels: ['figures.magnitudeVV.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.magnitudeVV,
      figure: 'figures/graph',
      annotation: null,
      source: 'magnitudeVV',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.vv',
        hoverTitles: { headerLabel: 'figures.magnitudeVV.x-hover', lineLabels: ['figures.magnitudeVV.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.phaseDegrees,
      figure: 'figures/graph',
      annotation: null,
      source: 'phaseDegrees',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.degree',
        hoverTitles: { headerLabel: 'figures.phaseDegrees.x-hover', lineLabels: ['figures.phaseDegrees.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.phaseRadians,
      figure: 'figures/graph',
      annotation: null,
      source: 'phaseRadians',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: -1,
        yticks: 6,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.radian',
        hoverTitles: { headerLabel: 'figures.phaseRadians.x-hover', lineLabels: ['figures.phaseRadians.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.groupDelay,
      figure: 'figures/graph',
      annotation: null,
      source: 'groupDelay',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~s',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.second',
        hoverTitles: { headerLabel: 'figures.groupDelay.x-hover', lineLabels: ['figures.groupDelay.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.phaseDelay,
      figure: 'figures/graph',
      annotation: null,
      source: 'phaseDelay',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~s',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.second',
        hoverTitles: { headerLabel: 'figures.phaseDelay.x-hover', lineLabels: ['figures.phaseDelay.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.stepResponse,
      figure: 'figures/graph',
      annotation: 'annotations/step-response-envelope',
      source: 'stepResponse',
      options: {
        xscale: 'linear',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: 8,
        yticks: 8,
        hover: true,
        xUnit: 'units.second',
        yUnit: 'units.vv',
        hoverTitles: { headerLabel: 'figures.stepResponse.x-hover', lineLabels: ['figures.stepResponse.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.inputImpedanceMagnitude,
      figure: 'figures/graph',
      annotation: null,
      source: 'inputImpedanceMagnitude',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'log',
        yformat: '.3~s',
        xticks: -1,
        yticks: -1,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.ohm',
        hoverTitles: {
          headerLabel: 'figures.inputImpedanceMagnitude.x-hover',
          lineLabels: ['figures.inputImpedanceMagnitude.y-hover'],
        },
      },
    },
    {
      name: FilterConstants.figureName.inputImpedancePhase,
      figure: 'figures/graph',
      annotation: null,
      source: 'inputImpedancePhase',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'linear',
        yformat: '.3~r',
        xticks: -1,
        yticks: 8,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.degree',
        hoverTitles: {
          headerLabel: 'figures.inputImpedancePhase.x-hover',
          lineLabels: ['figures.inputImpedancePhase.y-hover'],
        },
      },
    },
    {
      name: FilterConstants.figureName.noise,
      figure: 'figures/noise',
      annotation: null,
      source: 'noise',
      options: {
        xscale: 'log',
        xformat: '.4~s',
        yscale: 'log',
        yformat: '.3~s',
        xticks: -1,
        yticks: -1,
        hover: true,
        xUnit: 'units.hz',
        yUnit: 'units.snd',
        hoverTitles: { headerLabel: 'figures.noise.x-hover', lineLabels: ['figures.noise.y-hover'] },
      },
    },
    {
      name: FilterConstants.figureName.power,
      figure: 'figures/power',
      annotation: null,
      source: 'power',
      options: null,
    },
    {
      name: FilterConstants.figureName.voltageRange,
      figure: 'figures/voltage-range',
      annotation: null,
      source: 'voltageRange',
      options: null,
    },
    {
      name: FilterConstants.figureName.stages,
      figure: 'figures/stages',
      annotation: null,
      source: null,
      options: { xscale: 'log', yscale: 'linear' },
    },
    {
      name: FilterConstants.figureName.circuit,
      figure: 'figures/schematic',
      annotation: null,
      source: null,
      options: null,
    },
    {
      name: FilterConstants.figureName.billOfMaterials,
      figure: 'figures/bom',
      annotation: null,
      source: 'billOfMaterials',
      options: null,
    },
  ],
};
